import { render, staticRenderFns } from "./TabLiquidOxygenHazards.vue?vue&type=template&id=882a2e1a&scoped=true"
import script from "./TabLiquidOxygenHazards.vue?vue&type=script&lang=js"
export * from "./TabLiquidOxygenHazards.vue?vue&type=script&lang=js"
import style0 from "./TabLiquidOxygenHazards.vue?vue&type=style&index=0&id=882a2e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882a2e1a",
  null
  
)

export default component.exports